import React from 'react';
import { Switch, Route } from 'react-router-dom';

import {
  Home,
  RestaurantDetails,
  Cart,
  Login,
  Register,
  ResetPassword,
  UpdatePassword,
  UserRequests,
  UserRequestDetails,
  NotFound,
  Site,
} from 'pages';

import AppRoutes from './AppRoutes';
import AdminRoutes from './AdminRoutes';
import GarconRoutes from './GarconRoutes';

import PrivateRoute from './PrivateRoute';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/site" component={Site} />
      <Route exact path="/cart" component={Cart} />
      <Route exact path="/login" component={Login} />
      <Route exact path="/register" component={Register} />
      <Route exact path="/reset-password" component={ResetPassword} />
      <Route exact path="/reset-password/:token" component={UpdatePassword} />
      <Route exact path="/user-requests" component={UserRequests} />
      <Route exact path="/user-requests/:id" component={UserRequestDetails} />
      <Route exact path="/restaurants/:id" render={RestaurantDetails} />

      <PrivateRoute isPermmitedBy={[1]} path="/admin" component={AdminRoutes} />
      <PrivateRoute isPermmitedBy={[2]} path="/app" component={AppRoutes} />
      <PrivateRoute
        isPermmitedBy={[4]}
        path="/garcon"
        component={GarconRoutes}
      />
      <Route component={NotFound} />
    </Switch>
  );
}
